import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { MdClear } from "react-icons/md";
import "../Styles/Sidebar.css";
import { MdKeyboardArrowDown } from "react-icons/md";
import { CartState } from "../Context/Context";

let useClickOutside = (handler) => {
  let domNode = useRef();

  useEffect(() => {
    let maybeHandler = (event) => {
      if (!domNode.current.contains(event.target)) {
        handler();
      }
    };

    document.addEventListener("mousedown", maybeHandler);

    return () => {
      document.removeEventListener("mousedown", maybeHandler);
    };
  });

  return domNode;
};

export default function Sidebar(props) {
  const [showShop, setShowShop] = useState(false);
  const [showBrand, setShowBrand] = useState(false);
  const [showHelp, setShowHelp] = useState(false);

  let domNode = useClickOutside(() => {
    props.setShowMenu(false);
  });

  const {
    productDispatch,
  } = CartState();

  return (
    <div
      className="sidebar"
      style={{
        transform: props.showMenu ? "translateX(0)" : "translateX(-100%)",
      }}
      ref={domNode}
    >
      <div className="closeMenu">
        <MdClear
          className="closeIcon"
          onClick={() => props.setShowMenu(false)}
        />
      </div>

      <div className="navItems">
        <ul>
          <li onClick={() => setShowBrand(!showBrand)}>
            <Link to="#">THE BRAND</Link>
            <MdKeyboardArrowDown
              className="arrow-icons"
              style={{
                transform: showBrand ? "rotate(180deg)" : "rotate(0deg)",
              }}
            />
            <ul
              style={{ display: showBrand ? "block" : "none" }}
              onClick={() => props.setShowMenu(false)}
            >
              <li>
                <Link to="/journey">JOURNEY</Link>
              </li>
              <li>
                <Link to="/" onClick={props.click}>
                  WHY DOKMEN
                </Link>
              </li>
              <li>
                <Link to="#" onClick={props.showAlert}>
                  BLOG
                </Link>
              </li>
              <li>
                <Link to="/affiliate">BECOME AN AFFILIATE</Link>
              </li>
              <li>
                <Link to="/affiliate">CORPORATE GIFTING</Link>
              </li>
            </ul>
          </li>
          <li onClick={() => setShowShop(!showShop)}>
            <Link to="#">SHOP</Link>
            <MdKeyboardArrowDown
              className="arrow-icons"
              style={{
                transform: showShop ? "rotate(180deg)" : "rotate(0deg)",
              }}
            />

            <ul
              style={{ display: showShop ? "block" : "none" }}
              onClick={() => props.setShowMenu(false)}
            >
              <li>
                <Link
                  to="/products"
                  onClick={() => {
                    productDispatch({
                      type: "FILTER_BY_CATEGORY",
                      payload: "all",
                    });
                  }}
                >
                  ALL
                </Link>
              </li>
              <li>
                <Link
                  to="/products"
                  onClick={() => {
                    productDispatch({
                      type: "FILTER_BY_CATEGORY",
                      payload: "men",
                    });
                  }}
                >
                  MEN
                </Link>
              </li>
              <li>
                <Link
                  to="/products"
                  onClick={() => {
                    productDispatch({
                      type: "FILTER_BY_CATEGORY",
                      payload: "women",
                    });
                  }}
                >
                  WOMEN
                </Link>
              </li>
            </ul>
          </li>
          <li onClick={() => props.setShowMenu(false)}>
            <Link to="#" onClick={props.showAlert}>
              COMBOS
            </Link>
          </li>

          <li onClick={() => props.setShowMenu(false)}>
            <Link to="#" onClick={props.showAlert}>
              SALE
            </Link>
          </li>

          <li onClick={() => setShowHelp(!showHelp)}>
            <Link to="#">HELP</Link>
            <MdKeyboardArrowDown
              className="arrow-icons"
              style={{
                transform: showHelp ? "rotate(180deg)" : "rotate(0deg)",
              }}
            />
            <ul
              style={{ display: showHelp ? "block" : "none" }}
              onClick={() => props.setShowMenu(false)}
            >
              <li>
                <a
                  href="https://api.whatsapp.com/send?phone=+919820043813&text=I want to ask about Return and Exchange"
                  target="_blank"
                  rel="noreferrer"
                >
                  RETURNS / EXCHANGE
                </a>
              </li>
              <li>
                <a
                  href="https://api.whatsapp.com/send?phone=+919820043813&text=I want to track my order"
                  target="_blank"
                  rel="noreferrer"
                >
                  TRACK YOUR ORDER
                </a>
              </li>
              <li>
                <Link to="/returnpolicy">RETURN POLICY</Link>
              </li>
              <li>
                <Link to="#" onClick={props.showAlert}>
                  {" "}
                  CARE YOUR PPRODUCT
                </Link>
              </li>
              <li>
                <Link to="/affiliate">#ASK DOKMEN</Link>
              </li>
            </ul>
          </li>
        </ul>
        {/* <div className="log-in-btn">
          <button
            type="button"
            className="btn btn-primary"
            data-bs-toggle="modal" data-bs-target="#loginModal"
            onClick={() => props.setShowMenu(false)}

          >
            Log In
          </button>
        </div> */}
      </div>
    </div>
  );
}
